<rb-loading-spinner *ngIf="dataLoadingBCEvents" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="(errorMessageBCEvents || errorMessageCurrentBatteryCondition) && !dataLoadingBCEvents">
    <rb-callout type="warning">
        No data for "Fleet Battery Condition - Today" chart.
    </rb-callout>
</div>
<div [id]="chartId"></div>
<div class="p-2" *ngIf="!dataLoadingBCEvents && !errorMessageBCEvents && !errorMessageCurrentBatteryCondition">
    <div class="shaded-container">
        Share of vehicles within your fleet rated as "above average", "average", or "below average". This share is shown for the current status.
        Please note that the ratings for some batteries are still pending. The proportion of these batteries within the entire fleet is indicated in gray on the pie chart.
    </div>
</div>
